module.exports = __webpack_public_path__ + "web_static/img/community_background.659b1539.png";